import { CAMPAIGN } from "@/lib/campaign";
import { scrollToId } from "@/lib/scroll";

const DEFAULT_LINKS = [
  { label: "LEARN", id: "learn" },
  { label: "HOST", id: "host" },
  { label: "FAQ", id: "faq" },
];

export const Nav = ({ links = DEFAULT_LINKS, ctaLabel = "RESERVE MY FREE SEAT", ctaTarget = "register" }) => (
  <header className="fixed top-0 left-0 right-0 z-50 flex justify-center px-4 pt-4">
    <nav
      data-testid="main-nav"
      aria-label="Main"
      className="glass-panel rounded-[6px] w-full max-w-5xl flex items-center justify-between gap-4 px-4 md:px-6 py-2.5"
    >
      <a
        href="/"
        data-testid="nav-logo-link"
        className="flex items-center gap-2 shrink-0"
        aria-label="Kinsfolk Mortgage — home"
      >
        <img
          src={CAMPAIGN.logo}
          alt="Kinsfolk Mortgage"
          className="h-7 md:h-8 w-auto"
          style={{ filter: "brightness(0) invert(1)" }}
        />
      </a>
      <div className="hidden md:flex items-center gap-7">
        {links.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-link-${l.id}`}
            onClick={() => scrollToId(l.id)}
            className="font-mono text-[11px] tracking-[0.22em] text-[var(--muted)] hover:text-white transition-colors duration-200"
          >
            {l.label}
          </button>
        ))}
      </div>
      <button
        data-testid="nav-cta-button"
        onClick={() => scrollToId(ctaTarget)}
        className="glint bg-[var(--accent)] text-[var(--background-deep)] font-semibold text-[11px] md:text-xs tracking-[0.1em] px-4 md:px-5 py-2.5 rounded-[4px] hover:brightness-110 transition-[filter] duration-200 whitespace-nowrap"
      >
        {ctaLabel}
      </button>
    </nav>
  </header>
);
